import Component_DragNDrop_031adebecb944c02c2d7c5f0e3055937 from "../../../../content/examples/behaviors/drag-n-drop/DragNDrop";
import Devtool_DragNDrop_031adebecb944c02c2d7c5f0e3055937 from "!!@devtool/loader!../../../../content/examples/behaviors/drag-n-drop/DragNDrop";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_DragNDrop_031adebecb944c02c2d7c5f0e3055937,
  Devtool_DragNDrop_031adebecb944c02c2d7c5f0e3055937,
  DevTool,
  React
};